import { RemediationTag } from '../enums/RemediationTag';
import { Remediation } from '../models/Remediation';
import { ReferenceLinkMapper } from './ReferenceLinkMapper';

export class RemediationMapper {
  private readonly referenceLinkMapper = new ReferenceLinkMapper();

  mapGQLModel(data: any): Remediation {
    const { remediation, triage, specificRemediationAdvice, link } = data?.general || {};

    return new Remediation(remediation, triage || null, specificRemediationAdvice || null, this.referenceLinkMapper.mapFromPair(link));
  }

  mapSpecificTag(data: any): RemediationTag | null {
    return data?.specificTag ?? null;
  }
}
